import { FC, useMemo } from 'react';
import { typeHTHTerritory } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    hthTerritory: typeHTHTerritory;
};

export const HTHAllDoNotCalls: FC<propsType> = ({ hthTerritory }) => {
    const isDarkMode = useGetIsDarkMode();

    const doNotCalls = useMemo(() =>
        hthTerritory.faces.map(p => p.doNotCalls.map(d => ({ street: p.street, doNotCall: d }))).flat()
    , [hthTerritory.faces]);

    return (
        <>
        {doNotCalls.length ?
            <div className={'text-center'}>
                <h2 className={`${isDarkMode ? 'text-white' : ''} my-5`}>
                    No tocar del Territorio:
                </h2>
                {doNotCalls.map(d =>
                    <h5 key={d.doNotCall.id} className={isDarkMode ? 'text-white' : ''}>
                        {d.street} {d.doNotCall.streetNumber} {d.doNotCall.doorBell} - Fecha {d.doNotCall.date}
                    </h5>
                )}
            </div>
            :
            <h4 className={`text-center mt-4 ${isDarkMode ? 'text-white' : ''}`}>
                No hay No tocar en este Territorio
            </h4>
        }
        </>
    );
}
